/**
 * Two badges, not one badge with a variant: a review can carry both at once, and the design gives
 * them different palettes and different homes on the card — Verified Purchaser sits beside the
 * rating, Repeat Purchaser inside the author box.
 */

const BADGE_CLASS =
  'inline-flex shrink-0 items-center rounded-[4px] px-2 py-1 text-label-small font-medium whitespace-nowrap';

export const VerifiedPurchaserBadge = () => (
  <span data-testid="verified-purchaser-badge" className={`${BADGE_CLASS} bg-success-50 text-success-600`}>
    Verified Purchaser
  </span>
);

export const RepeatPurchaserBadge = () => (
  <span data-testid="repeat-purchaser-badge" className={`${BADGE_CLASS} bg-primary-50 text-primary-600`}>
    Repeat Purchaser
  </span>
);
